// packages/components/src/layout/StoryBlock.tsx

import React from 'react';
import { motion } from 'framer-motion';
import clsx from 'clsx';
import { renderIcon } from '@dopomogai/utils';
import { IconName } from '@dopomogai/ui';

// Define the component's props interface
interface StoryBlockProps {
  iconName: IconName | string;
  title: string;
  text: React.ReactNode; // Accept ReactNode for rich text
  visual: React.ReactNode;
  isReversed?: boolean;
}

export const StoryBlock: React.FC<StoryBlockProps> = ({ iconName, title, text, visual, isReversed = false }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.6 }}
      className={clsx("grid lg:grid-cols-2 gap-x-16 gap-y-12 items-center")}
    >
      <div className={clsx(isReversed && "lg:order-last")}>
        {visual}
      </div>
      <div className={clsx("space-y-4", isReversed ? "lg:order-first" : "")}>
        <div className="flex items-center gap-4">
          <span className="p-3 bg-white border-2 border-black rounded-lg w-fit">
            {renderIcon(iconName as IconName, { size: 24, className: 'text-slate-700' })}
          </span>
          <h3 className="text-2xl font-bold text-gray-900">{title}</h3>
        </div>
        <div className="text-slate-700 leading-relaxed text-base prose prose-slate">
            {text}
        </div>
      </div>
    </motion.div>
  );
};